import { Component, OnInit, ElementRef, AfterContentChecked } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-customer-eligibility',
    templateUrl: './customer-eligibility.component.html',
    styleUrls: ['./customer-eligibility.component.scss'],
    standalone: false
})
export class CustomerEligibilityComponent extends CfetBaseComponent implements OnInit, AfterContentChecked {

  showCancelModal = false;
  openCancelModal = '';
  divHeight2: number;
  divHeight1: number;
  selectedZipInWorkplace: any;
  selectedStateInWorkplace: any;
  selectedCity: any;
  selectedAddress: any;
  selectedWorkPlace: any;
  selectedRole: any;
  showWorkPlaceSection = false;
  signupCompleted = false;
  editButtonClicked: boolean;
  showMobileEditButton = false;
  showDesktopEditButton = false;
  showStepCompleteHeading = false;
  showInfoSection = false;
  showEligibilitySection = true;
  showHeading = true;
  disableStep = true;
  stepThreeSelected = false;
  stepThreeIcon = true;
  stepTwoDone = false;
  stepTwoSelected = false;
  stepTwoIcon = true;
  stepOneDone = false;
  stepOneTickIcon = false;
  stepOneSelected = true;
  stepOneIcon = true;

  constructor(private title: Title,
    private elementRef: ElementRef,
    private router: Router,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.eligibility.htmlTitle);
    this.loadCommonListValuesData();
    this.cfetService.isLandingPage.next(false);
  }

  ngAfterContentChecked() {
    this.divheightCalc();
  }

  changeOrientation(event) {
    if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'landscape-primary') {
      this.showMobileEditButton = false;
      this.showDesktopEditButton = true;
      this.showWorkPlaceSection = true;
    } else if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'portrait-primary') {
      this.showMobileEditButton = true;
      this.showDesktopEditButton = false;
      this.showWorkPlaceSection = false;
    }
  }

  stepOne() {
    this.stepOneSelected = true;
    this.stepTwoSelected = false;
    this.stepThreeSelected = false;
  }

  stepTwo() {
    if (this.disableStep) {
      this.stepTwoSelected = false;
    } else {
      this.stepTwoSelected = true;
      this.stepOneSelected = false;
      this.stepThreeSelected = false;
    }
  }

  stepThree() {
    if (this.disableStep) {
      this.stepThreeSelected = false;
    } else {
      this.stepThreeSelected = true;
      this.stepTwoSelected = false;
      this.stepOneSelected = false;
    }
  }

  divheightCalc() {
    const divElem2 = this.elementRef.nativeElement.querySelector('#form-component-section').children[0];
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (screen.width > 1024) {
      if (divElem2.scrollHeight > (93.4 * vh / 100)) {
        this.divHeight1 = divElem2.scrollHeight;
      } else {
        this.divHeight1 = 93.4 * vh / 100;
        this.divHeight2 = 93.4 * vh / 100;
      }
    } else {
      const bodyelement = this.elementRef.nativeElement.querySelector('#cutomer-eligibility-screen').children[0];
      const progresstrackerelement = this.elementRef.nativeElement.querySelector('#progress-tracker');
      const formcomponentsection = this.elementRef.nativeElement.querySelector('#form-component-section');
      if (bodyelement.scrollHeight <= progresstrackerelement.scrollHeight + formcomponentsection.scrollHeight) {
        const bodyheight = progresstrackerelement.scrollHeight + formcomponentsection.scrollHeight;
        bodyelement.style.height = bodyheight + 'px';
      } else {
        bodyelement.style.height = 70.4 * vh / 100 + 'px';
      }
    }
  }

  goToEligibility(event) {
    this.editButtonClicked = true;
    this.showInfoSection = false;
    this.showEligibilitySection = true;
    // disable Second Step and go to Step One
    this.disableStep = true;
    this.stepOne();
    this.stepOneIcon = true;
    this.stepOneTickIcon = false;
    this.showHeading = true;
    this.showStepCompleteHeading = false;
    this.showDesktopEditButton = false;
    this.showMobileEditButton = false;
    this.stepOneDone = false;
    this.showWorkPlaceSection = false;
  }

  onEligibilityCompletion(event) {
    if (event !== undefined && event.editIconSelected === true) {
      this.stepOneIcon = true;
      this.stepOneTickIcon = false;
    }
    if (event !== undefined && event.editIconSelected !== true) {
      this.stepOneIcon = false;
    }
    if (event && event.editIconSelected !== true && event.eligibilityStatus) {
      this.stepOneTickIcon = event.eligibilityStatus.completionStatus;
    }
    if (event !== undefined && this.stepOneTickIcon) {
      this.selectedRole = event.selectedRole;
      this.selectedWorkPlace = event.eligibilityStatus.selectedName;
      this.selectedAddress = event.eligibilityStatus.selectedAddress;
      this.selectedCity = event.eligibilityStatus.selectedCity;
      this.selectedStateInWorkplace = event.eligibilityStatus.selectedStateInWorkplace;
      this.selectedZipInWorkplace = event.eligibilityStatus.selectedZipInWorkplace;
    }
    // On click of signup button
    if (event && event.eligibilityStatus && event.eligibilityStatus.signupDoneStatus) {
      this.signupCompleted = true;
      this.showInfoSection = true;
      this.showEligibilitySection = false;
      const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        || isIPadPro) {
        this.stepOneTickIcon = true;
        this.showHeading = false;
        this.showStepCompleteHeading = true;
        this.stepOneDone = true;
        this.showMobileEditButton = true;
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = false;
        this.disableStep = false;
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION]);
      } else {
        this.stepOneTickIcon = true;
        this.showHeading = false;
        this.showStepCompleteHeading = true;
        this.showDesktopEditButton = true;
        this.showMobileEditButton = false;
        this.stepOneDone = true;
        this.showWorkPlaceSection = true;
        this.disableStep = false;
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION]);
      }
    }
  }

  cancelModal(event) {
    if (event) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  async loadCommonListValuesData() {
    if (!sessionStorage.getItem('ngStorage-commonListValues') ||
      Object.keys(sessionStorage.getItem('ngStorage-commonListValues')).length === 0) {
      await this.cfetService.getCommonList();
    }
  }

}
